<template>
    <dismissible-banner
        v-if="showBanner"
        id="ReflowBanner"
        v-bind:banner-model="bannerModel"
        class="p-2">
        <template v-slot:default>
            <div class="text-center">
                <i18n-t
                    scope="global"
                    keypath="reflowBanner.bannerMessage2025"
                    tag="div">
                    <template v-slot:linkText>
                        <a
                            href="https://reflow-2025.vfairs.com/"
                            target="_blank"
                            data-gtmid="Reflow2025-Register">
                            {{ registerLinkText2025 }}
                        </a>
                    </template>
                </i18n-t>
            </div>
        </template>
    </dismissible-banner>
</template>
<script>
    import dismissibleBanner from "./dismissibleBanner.vue";
    import { BANNER_STYLE } from "./banners";
    import { KEYS, NAMESPACE } from "./i18n/reflowBanner.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        components: {
            dismissibleBanner
        },
        props: {
            colsKey: { type: String, required: true }
        },
        computed: {
            showBanner() {
                return this.$app.LoggedInRole.IsProgramAdmin || this.$app.LoggedInRole.IsCPAdmin;
            },
            bannerModel() {
                return {
                    ShowBanner: this.showBanner,
                    AllowHideIndefinite: false,
                    ShowHideCOLSKey: this.colsKey,
                    BannerStyle: BANNER_STYLE.info,
                    AutoHideAfterMs: 60000,
                    HideExpirationDays: 1
                };
            },
            ...mapI18n(KEYS, NAMESPACE)
        }
    };
</script>
